/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = LocationTransferItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class LocationTransferItemsEditor extends _Ext.ItemGridEditor<LocationTransferItemsRow> {
        protected getColumnsKey() { return "Inventory.LocationTransferItems"; }
        protected getDialogType() { return LocationTransferItemsDialog; }
        protected getLocalTextPrefix() { return LocationTransferItemsRow.localTextPrefix; }

        protected form: LocationTransferItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        DepartmentId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        DeptId: number = 0;
        public TotalItems: number;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as LocationTransferDialog).CalculateAmountandTax(this.view.getItems());
                }
            })
        }



        protected createToolbarExtensions(): void {
            super.createToolbarExtensions();
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            //    Q.first(columns, x => x.field === fld.WstPer).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => {
                        /*if (item.TransItemId > 0) {

                            // **** Validate StockId from Stock Transactions ****
                            let StockID;
                            Stock.StockItemService.GetStockTransactions({
                                LineNo: item.Line_No,
                                RefTransId: item.TransId,
                                ProductId: item.ProductId,
                                Take: 1
                            },
                                response => StockID = response.Entities,
                                {
                                    async: false
                                });

                            //Q.alert
                            if (StockID.length > 0) {
                                Q.alert("This Item is used in other transactions, Can Not Delete!!");
                                return;
                            }
                            else {
                                Inventory.LocationTransferItemsService.Delete({ EntityId: item.TransItemId });
                                StockID.foreach(function (value) {
                                    Stock.StockItemService.Delete({ EntityId: value.StockId });

                                });
                                
                                var id = this.id(item);
                                this.TotalItems = this.view.getItems().length - 1;
                                this.view.deleteItem(id);
                            }
                        }
                        else {*/
                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    //if (item.WstPer != null) {
                    //    item.WstWt = item.NetWeight * (item.WstPer / 100);
                    //}
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.NetWeight * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as LocationTransferDialog).CalculateAmountandTax(this.view.getItems());

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as LocationTransferDialog).RateListId;
            this.LaborListId = (this.parentDialog as LocationTransferDialog).LaborListId;
            this.StoneMarkup = (this.parentDialog as LocationTransferDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as LocationTransferDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as LocationTransferDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as LocationTransferDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as LocationTransferDialog).form.ExchRate.value;
            this.TransDate = (this.parentDialog as LocationTransferDialog).form.TransDate.valueAsDate;
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid;
            buttons = buttons.filter(x => x.cssClass != "add-button");
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.DeptId == 0) {
                        Q.notifyWarning("Please select Department to Transfer From to proceed");
                        return;
                    }
                    else {
                        var deptid = parseInt((this.parentDialog as LocationTransferDialog).form.FromDepartmentId.value);
                        var filters: _Ext.SelectGridFilters = {
                            DepartmentId: deptid,
                            FilterItems: 5
                        }

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });

                        pickerDialog.onSuccess = (selectedItems: any[]) => {
                            let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                            var ItemDetails = ItemGridHelper.SetLocationTransferItemGrid(selectedItems2, new Date(), 0, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);

                            for (let Item of ItemDetails) {
                                Item[this.getIdProperty()] = "`" + this.nextId++;
                                this.view.addItem(Item);
                                this.view.refresh();
                            }

                        }
                        // #endregion

                        pickerDialog.dialogOpen();
                    }

                }
            });

            return buttons;
        }

        // #endregion
    }
}